import { RND } from "./RND";



export abstract class NumValBase {
    /**
     * Vychozi generator nahodnch cisel, ktery se pouzije, pokud neni predan generator do metody getValue()
     */
    public static defaultRnd: RND;

    //-------------------------------------------------------------------------
    /**
     * Vraci hodnotu. Hodnota muze byt po kazdem volani jina
     */
    //-------------------------------------------------------------------------
    abstract getValue(rnd?: RND): number;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    static getValue(val: number | NumValBase, rnd?: RND): number {
        return val instanceof NumValBase ? val.getValue(rnd) : val;
    }
}



/**
 * Nahrada klasickeho typu "number"
 */
export class FixedNumVal extends NumValBase {
    private _val: number;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor(val: number) {
        super();
        this._val = val;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    getValue(rnd?: RND): number { return this._val; }
}



/**
 * Nahodne cislo v rozsahu min az max.
 * Vyber bude provedem bud
 * A) zcela nahodne
 * B) v urcitem kroku (napr. 0.5, 0.25 a podobne)
 * C) jen cela cisla
 */
export class RndNumVal extends NumValBase {
    private _minVal: number;
    private _maxVal: number;
    private _partsNum: number;

    //-------------------------------------------------------------------------
    /**
     * @param minVal Minimalni hodnota
     * @param maxVal Maximalni hodnota
     * @param partsNum Pocet dilu, ze kterych je mozne vybirat. 
     * Pokud == 1, tak se vybere nahodne cislo s desetinnou carkou v rozmezi min az max
     * Pokud <= 0, tak se nahodne vybere cele cislo v rozmezi min az max (vcetne)
     * Pokud >  1, tak se rozsah min az max rozdeli na pozadovany pocet dilu a vysledne cislo bude v tomto kroku
     */
    //-------------------------------------------------------------------------
    constructor(minVal: number, maxVal: number, partsNum: number = 1) {
        super();

        this._minVal = minVal;
        this._maxVal = maxVal;

        if (partsNum < 1)
            partsNum = maxVal - minVal;

        this._partsNum = partsNum;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    getValue(rnd?: RND): number {
        if (!rnd)
            rnd = NumValBase.defaultRnd;

        if (this._partsNum == 1) {
            return rnd.randomIn(this._minVal, this._maxVal);
        }

        let partId = rnd.randomIntIn(0, this._partsNum);

        return this._minVal + partId * ((this._maxVal - this._minVal) / this._partsNum);
    }
}



/**
 * Cislo z vyberu nekolika moznych
 */
export class SelNumVal extends NumValBase {
    private _vals: number[];

    //-------------------------------------------------------------------------
    /**
     * @param vals Seznam moznych hodnot
     */
    //-------------------------------------------------------------------------
    constructor(vals: number[]) {
        super();

        this._vals = vals;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    getValue(rnd?: RND): number {
        if (!rnd)
            rnd = NumValBase.defaultRnd;

        return this._vals[rnd.randomIntIn(0, this._vals.length - 1)];
    }
}